import { Analytics } from "@vercel/analytics/react"
import LandingPage from './Pages/Landing/LandingPage';
import './App.css';

function App() {
  return (
    <>
    
   
    <LandingPage />
    </>
    

  );
}

export default App;
